import initialState from "./InitialState";

const tabsReducer = (state=initialState.tabs, action) => {
    return state;
}

export default tabsReducer;